import { InfoChipsPropertiesType } from "@website/ui/info-chips/info-chips.types";
import pick from "lodash-es/pick";

export const useInfoChips = (properties: InfoChipsPropertiesType) => ({
  infoChipsProps: {
    ...pick(properties, "aria-label", "id", "data-testid", "onClick")
  }
});
